import { eq, string } from 'fp-ts';
import { Address, InlinedAddress } from '@mews-commander/data-access';
import { AddressFormValues } from './types';

export const inlinedAddressToFormValues = (address: InlinedAddress) => ({
    addressLine1: address?.line1 ?? '',
    addressLine2: address?.line2 ?? '',
    city: address?.city ?? '',
    postalCode: address?.postalCode ?? '',
    countryCode: address?.countryCode ?? '',
    countrySubdivisionCode:
        address?.countryCode && address?.subdivisionCode ? `${address.countryCode}-${address.subdivisionCode}` : '',
});

export const addressToFormValues = (address: Omit<Address, 'id' | 'isComplete'>) => ({
    addressLine1: address?.addressLine1 ?? '',
    addressLine2: address?.addressLine2 ?? '',
    city: address?.city ?? '',
    postalCode: address?.postalCode ?? '',
    countryCode: address?.countryCode ?? '',
    countrySubdivisionCode: address?.countrySubdivisionCode ?? '',
});

export const addressFormValuesEq = eq.struct<AddressFormValues>({
    addressLine1: string.Eq,
    addressLine2: string.Eq,
    city: string.Eq,
    postalCode: string.Eq,
    countryCode: string.Eq,
    countrySubdivisionCode: string.Eq,
});
